import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { Capabilities } from '@/sections/Capabilities';
import { Contact } from '@/sections/Contact';
import { Hero } from '@/sections/Hero';
import { Process } from '@/sections/Process';
import { Services } from '@/sections/Services';
import { Testimonials } from '@/sections/Testimonials';
import { Work } from '@/sections/Work';

/**
 * The page. Sections are composed in reading order and each owns its own data,
 * layout and styles — App only decides the sequence.
 */
export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <Header />

      <main id="main">
        <Hero />
        <Services />
        <Process />
        <Work />
        <Capabilities />
        <Testimonials />
        <Contact />
      </main>

      <Footer />
    </>
  );
}
